import { useQuery } from "@tanstack/react-query";
import { VoicesAPI } from "../api/voices";
import { useCurrentClient } from "@/features/clients/hooks/use-clients";

export const voiceKeys = {
  all: ["voices"] as const,
  lists: () => [...voiceKeys.all, "list"] as const,
  list: (clientId: string) => [...voiceKeys.lists(), clientId] as const,
  providers: (clientId: string) =>
    [...voiceKeys.all, "providers", clientId] as const,
  sample: (
    clientId: string,
    voiceId: string,
    temperament: string,
    language: string,
  ) =>
    [...voiceKeys.all, "sample", clientId, voiceId, temperament, language] as const,
};

export function useVoices() {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";

  return useQuery({
    queryKey: voiceKeys.list(clientId),
    queryFn: async () => {
      const data = await VoicesAPI.list(clientId);
      return data.voices;
    },
    enabled: !!clientId,
  });
}

// Voice providers actually usable on this deployment (have credentials + reachable).
// Used to filter the voice picker so only selectable/working voices are shown.
export function useVoiceProviders() {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";

  return useQuery({
    queryKey: voiceKeys.providers(clientId),
    queryFn: async () => {
      const data = await VoicesAPI.listProviders(clientId);
      return data.providers;
    },
    enabled: !!clientId,
  });
}
